// extracted by mini-css-extract-plugin
export default {"unFormalizedZipSection":"Zh_3Tm3h","unFormalizedZipHeader":"wdZpU2Zc","createZipButton":"eOcBfHGj"};